import React from "react";
import { Timer } from "lucide-react";

export default function QuestionGaming({ question, value, onChange, disabled }) {
    const selectedOptionId = value?.selectedOptionId ?? value;
    const timerSeconds = Number(question.configJson?.timer_s || question.dureeQuestionS || 0);

    return (
        <div className="qr-gaming">
            {timerSeconds > 0 ? (
                <div className="qr-gaming-timer">
                    <Timer size={16} />
                    {timerSeconds}s
                </div>
            ) : null}
            <div className="qr-options-list qr-options-list--compact">
                {(question.reponsesPossibles || []).map((option) => (
                    <label key={option.id} className={`qr-option-card ${String(selectedOptionId) === String(option.id) ? "is-selected" : ""}`}>
                        <input
                            type="radio"
                            name={`question-${question.id}`}
                            value={option.id}
                            checked={String(selectedOptionId) === String(option.id)}
                            onChange={() => onChange({ selectedOptionId: option.id })}
                            disabled={disabled}
                        />
                        <span>{option.libelle}</span>
                    </label>
                ))}
            </div>
        </div>
    );
}
